import { useLanguage } from '../../../localization/useLanguage';
import { IconChevronLeft, IconStar } from '../../Common/Icons';
import styles from './StarredRow.module.scss';

/**
 * Header of the starred list, and the only way back to the recent list.
 *
 * Mirrors ArchivedRow: the screen is opened from the overflow menu, so there is no entry
 * point here.
 *
 * @param count Number of starred messages.
 * @param onBack Returns to the recent list.
 */
export default function StarredRow({ count, onBack }) {
    const { t } = useLanguage();

    return (
        <button type="button" className={styles.header} onClick={onBack} aria-label={t('chat.starred.CLOSE')}>
            <span className={styles.back}>
                <IconChevronLeft />
            </span>
            <span className={styles.icon}>
                <IconStar />
            </span>
            <span className={styles.label}>{t('chat.STARRED_TITLE')}</span>
            <span className={styles.meta}>{count}</span>
        </button>
    );
}
